import React, { useContext, useState, useEffect } from 'react'
import AddAttachmentsRPSupportingDocumentButton from '../../../shared/components/add-attachments-rp-supporting-document-button/AddAttachmentsRPSupportingDocumentButton'
import AddAttachmentsRPGrid from '../../add-attachments-rp-grid/AddAttachmentsRPGrid'
import { ColumnBodyOptions, ColumnProps } from 'primereact/column'
import { DataTableProps } from 'primereact/datatable'
import { IAddAttachmentsRPTestSupportingDocumentModel } from '../../../shared/interfaces/IAddAttachmentsRPTestSupportingDocumentModel'
import classes from './AddAttachmentsRPTRSupportDoc.module.scss'
import RequiredAsterisk from '../../../shared/components/required-asterisk/RequiredAsterisk'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { faClose, faEdit, faLink, faTrash } from '@fortawesome/free-solid-svg-icons'
import { AddAttachmentsRPContext } from '../../../shared/contexts/AddAttachmentsRPContext'
import {
  attachmentTypeKeyName,
  contentGroupKeyName,
  displayUnlinkEcmModalHeader,
  internalAttachmentTypeKeyName,
  MAXIMUM_ALLOWED_UPLOAD_RP_FILE_SIZE,
  reportTypeKeyName,
  RPAttachmentLinkButtonEnum,
  RPFileValidatorSuccessMessage,
} from '../../../shared/constants/AddAttachmentsRPConstants'
import { AddAttachmentsRPFileValidatorHelper } from '../../../shared/helpers/AddAttachmentsRPFileValidatorHelper'
import { DropzoneOptions, useDropzone } from 'react-dropzone'
import { v4 as uuid } from 'uuid'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { formatRPDate } from '../../../shared/helpers/AddAttachmentsRPHelpers'
import { AddAttachmentsRPUtils } from '../../../shared/utils/AddAttachmentsRPUtils'
import { InputText } from 'primereact/inputtext'
import { IAddAttachmentsRPTRBulkEditDialogProps } from '../../../shared/interfaces/non-model/IAddAttachmentsRPTestReportBulkEditDialogProps'
import AddAttachmentsRPBulkEditDialog from '../../../shared/components/add-attachments-rp-bulk-edit-dialog/AddAttachmentsRPBulkEditDialog'
import { IAddAttachmentsRPTabDefaultProps } from '../../../shared/interfaces/IAddAttachmentsRPTabDefaultProps'
import { Checkbox } from 'primereact/checkbox'
import CertificateDetailsRPStatusIcon from '../../../../../certificate-details/certificate-details-rp-attachments/certificate-details-rp-status-icon/CertificateDetailsRPStatusIcon'
import { IAddAttachmentsRPTestReportModel } from '../../../shared/interfaces/IAddAttachmentsRPTestReportModel'
import useToastr from '../../../../../../../../hooks/useToastr'
import { IConfirmationModalProps } from '../../../shared/interfaces/non-model/IConfirmationModalProps'
import CertificateListService from '../../../../../../../../services/CertificateListService'
import { CertificateDocumentStatus } from '../../../../../../../../enums/CertificateDocumentStatus'
import {
  LinkToWbBtnText,
  UnlinkEcmBtnText,
} from '../../../../../../../../utils/constants/certificate.constants'
import CertificateDetailsRPLinkButton from '../../../../../certificate-details/certificate-details-rp-attachments/certificate-details-rp-link-button/CertificateDetailsRPLinkButton'
import {
  ecmUnavailableHeader,
  ecmUnavailableMessage,
} from '../../../../../../../../utils/constants/ecm.constants'
import { IEcmCertificateDocumentActionRequest } from '../../../shared/interfaces/IEcmCertificateDocument'
import ConfirmationModal from '../../../../../../../../shared/confirmation-modal/ConfirmationModal'
import useCertificateDocument from '../../../../../../../../hooks/useCertificateDocument'
import { SchemeEcmType } from '../../../../../../../../enums/SchemeEcmType'

interface AddAttachmentsRPTRSupportDocProps extends IAddAttachmentsRPTabDefaultProps {
  rpAttachments: IAddAttachmentsRPTestReportModel[]
  setRPAttachments: React.Dispatch<React.SetStateAction<IAddAttachmentsRPTestReportModel[]>>
  wrapperClassName?: string
  actionRowClassName?: string
  gridContainerClassName?: string
  serviceRequestNumber?: string
  projectNumber: string
  issueDate: Date | string | null
  fileNumber: string
  referenceNumber: string
  standardNumber: string
  certificateNumber: string
  revisionNumber: string
  parentId: string
  type: string
  value: IAddAttachmentsRPTestSupportingDocumentModel[]
  downloadFile: (
    file: IAddAttachmentsRPTestReportModel | IAddAttachmentsRPTestSupportingDocumentModel
  ) => Promise<void>
  setConfirmationModalProps: React.Dispatch<React.SetStateAction<IConfirmationModalProps>>
  shouldUpdateRPAttachments?: () => void
  updateRPAttachmentOnParent?: (updatedRPAttachment: IAddAttachmentsRPTestReportModel[]) => void
  certificateId?: string | undefined
  currentStep?: number
  selectedRows: IAddAttachmentsRPTestSupportingDocumentModel[]
  setSelectedRows: React.Dispatch<
    React.SetStateAction<IAddAttachmentsRPTestSupportingDocumentModel[]>
  >
  certificateScheme: string
}

enum SupportingDocumentDropdownFields {
  contentGroup,
  type,
  attachmentType,
  internalAttachmentType,
}

const AddAttachmentsRPTRSupportDoc = (props: AddAttachmentsRPTRSupportDocProps) => {
  const { standardNumber, setSelectedRows, selectedRows } = props
  const addAttachmentsRPContext = useContext(AddAttachmentsRPContext)
  const certificateDocumentHook = useCertificateDocument()
  const supportingDocumentsAllowedFileTypes: string[] =
    AddAttachmentsRPUtils.supportingDocumentAllowedFileTypes

  const { showError, showSuccess, showWarning } = useToastr()

  const [isSelectAll, setIsSelectAll] = useState<boolean>(false)

  const [bulkEditDialog, setBulkEditDialog] = useState<IAddAttachmentsRPTRBulkEditDialogProps>({
    dropdownOptions: [],
    title: '',
    visible: false,
    isContentGroup: false,
  })

  const initialConfirmationModalValues: IConfirmationModalProps = {
    onConfirm: () => {},
    onCancel: () => {},
    visible: false,
    headerDisplay: '',
    buttonNoDisplay: 'No',
    buttonYesDisplay: 'Yes',
    confirmationMessageHTML: '',
    style: undefined,
    isSaving: undefined,
  }

  const [confirmationModalProps, setConfirmationModalProps] = useState<IConfirmationModalProps>(
    initialConfirmationModalValues
  )

  useEffect(() => {
    // sync isSelectAll when selectedRows changes from parent
    const selectableRows = getSelectableRowsForCurrentParent()
    const selectedRowsForCurrentParent = getSelectedRowsForCurrentParent()

    const isAllSelected =
      selectedRowsForCurrentParent.length === selectableRows.length &&
      selectedRowsForCurrentParent.length > 0
    setIsSelectAll(isAllSelected)
  }, [selectedRows, props.rpAttachments, props.parentId])

  const gridProps: DataTableProps = {
    value: props.value,
    size: 'small',
    emptyMessage: () => {
      return <span>No files available.</span>
    },
  }

  const filteredCgDropdownSecondLevelOptions = AddAttachmentsRPUtils.filterCgSecondLevelOptions(
    AddAttachmentsRPUtils.transformDropdownOptions(
      addAttachmentsRPContext.ecmCategoryModel,
      contentGroupKeyName
    )
  )

  const rtDropdownOptions = AddAttachmentsRPUtils.transformDropdownOptions(
    addAttachmentsRPContext.ecmCategoryModel,
    reportTypeKeyName
  )

  const attachmentTypeDropdownOptions = AddAttachmentsRPUtils.transformDropdownOptions(
    addAttachmentsRPContext.ecmCategoryModel,
    attachmentTypeKeyName,
    true
  )

  const internalAttachmentTypeDropdownOptions = AddAttachmentsRPUtils.transformDropdownOptions(
    addAttachmentsRPContext.ecmCategoryModel,
    internalAttachmentTypeKeyName,
    true
  )

  const isRowEditable = (row: IAddAttachmentsRPTestSupportingDocumentModel) =>
    !AddAttachmentsRPUtils.isFieldReadonly(row.ecmFileNodeId, props.isCertificateFromRevision)

  const isSelectableRow = (row: IAddAttachmentsRPTestSupportingDocumentModel) =>
    row.isValid &&
    (AddAttachmentsRPUtils.isDocumentAllowedToLink(
      props.certificateScheme,
      row.contentGroup,
      row.attachmentType
    ) ||
      isRowEditable(row))

  const getSelectableRowsForCurrentParent = () =>
    props.rpAttachments
      .filter(rpAttachment => rpAttachment.id === props.parentId)
      .flatMap(rpAttachment => rpAttachment.supportingDocuments || [])
      .filter(isSelectableRow)

  const getSelectedRowsForCurrentParent = () =>
    selectedRows.filter(row =>
      props.rpAttachments
        .filter(rpAttachment => rpAttachment.id === props.parentId)
        .flatMap(rpAttachment => rpAttachment.supportingDocuments || [])
        .some(doc => doc.id === row.id)
    )

  const handleCheckboxSelection = (
    isHeaderCheckbox: boolean,
    isChecked: boolean,
    data?: IAddAttachmentsRPTestSupportingDocumentModel
  ) => {
    const cloneCurrentSelection = structuredClone(selectedRows)
    const selectableRows = getSelectableRowsForCurrentParent()
    const selectedRowsForCurrentParent = getSelectedRowsForCurrentParent()

    if (isHeaderCheckbox) {
      if (isChecked) {
        const newSelection = cloneCurrentSelection.filter(
          row => !selectableRows.some(selectableRow => selectableRow.id === row.id)
        )
        setSelectedRows([...newSelection, ...selectableRows])
        setIsSelectAll(true)
      } else {
        const newSelection = cloneCurrentSelection.filter(
          row => !selectableRows.some(selectableRow => selectableRow.id === row.id)
        )
        setSelectedRows(newSelection)
        setIsSelectAll(false)
      }
      return
    }

    if (data && isSelectableRow(data)) {
      const isAlreadySelected = cloneCurrentSelection.some(selected => selected.id === data.id)

      if (!isAlreadySelected) {
        cloneCurrentSelection.push(data)
      } else {
        const index = cloneCurrentSelection.findIndex(selected => selected.id === data.id)
        cloneCurrentSelection.splice(index, 1)
      }

      setSelectedRows(cloneCurrentSelection)

      const updatedSelectedForCurrentParent = cloneCurrentSelection.filter(row =>
        selectableRows.some(selectableRow => selectableRow.id === row.id)
      )

      const isAllSelected =
        updatedSelectedForCurrentParent.length === selectableRows.length &&
        selectableRows.length > 0

      setIsSelectAll(isAllSelected)
    }
  }

  const handleDeleteFileAttachment = (
    index: number,
    data: IAddAttachmentsRPTestSupportingDocumentModel
  ) => {
    const cloneCurrent = structuredClone(props.value)
    const cloneCurrentSelection = structuredClone(selectedRows)

    const getItemIndex = cloneCurrentSelection.findIndex(selected => selected.id === data.id)

    if (getItemIndex >= 0) cloneCurrentSelection.splice(getItemIndex, 1)

    cloneCurrent.splice(index, 1)

    const cloneTR = structuredClone(props.rpAttachments).map(cur => {
      if (cur.id === props.parentId) cur.supportingDocuments = cloneCurrent

      return cur
    })

    const isAllChecked =
      cloneTR
        .filter(rpAttachment => rpAttachment.id === props.parentId)
        .flatMap(rpAttachment =>
          rpAttachment.supportingDocuments.filter(
            suppDoc =>
              !AddAttachmentsRPUtils.isFieldReadonly(
                suppDoc.ecmFileNodeId,
                props.isCertificateFromRevision
              ) && suppDoc.isValid
          )
        ).length === cloneCurrentSelection.length

    props.setRPAttachments(cloneTR)

    if (props.updateRPAttachmentOnParent) props.updateRPAttachmentOnParent(cloneTR)

    setSelectedRows(cloneCurrentSelection)
    setIsSelectAll(isAllChecked)
  }

  const deleteConfirmationMessage = () => {
    return (
      <span>
        The document(s) will be deleted from GMAWB File Storage.
        <br />
        <br />
        Would you like to continue?
      </span>
    )
  }
  const showDeleteFileBlobPrompt = (
    rpAttachment: IAddAttachmentsRPTestSupportingDocumentModel,
    index: number
  ) => {
    props.setConfirmationModalProps(current => ({
      ...current,
      visible: true,
      headerDisplay: 'Delete File Confirmation',
      confirmationMessageHTML: deleteConfirmationMessage(),
      onCancel: () => resetModal(),
      onConfirm: () => handleDeleteFileBlobStorage(rpAttachment, index),
    }))
  }

  const resetModal = () => {
    props.setConfirmationModalProps(AddAttachmentsRPUtils.initialConfirmationModalValues)
  }

  const handleDeleteFileBlobStorage = async (
    rpAttachment: IAddAttachmentsRPTestSupportingDocumentModel,
    index: number
  ) => {
    props.setConfirmationModalProps(current => ({
      ...current,
      isSaving: true,
    }))

    const response = await CertificateListService.deleteFileFromBlob(rpAttachment.id)
    if (response.isSuccess === false) {
      resetModal()
      showError('Error!', 'Attachment(s) has not been deleted.')
      props.setConfirmationModalProps(current => ({
        ...current,
        isSaving: false,
      }))
      return
    } else {
      handleDeleteFileAttachment(index, rpAttachment)

      if (props.shouldUpdateRPAttachments) props.shouldUpdateRPAttachments()

      showSuccess(
        'Success!',
        'Attachment(s) has been deleted successfully from GMAWB File Storage.'
      )
      resetModal()
    }
  }

  const handleDropdownChange = (
    dropdownField: SupportingDocumentDropdownFields,
    rowData: IAddAttachmentsRPTestSupportingDocumentModel,
    value: string
  ) => {
    const cloneCurrent = structuredClone(props.rpAttachments).map(cur => {
      if (cur.id === props.parentId) {
        cur.supportingDocuments = cur.supportingDocuments.map(supportingDocument => {
          if (supportingDocument.id === rowData.id) {
            switch (dropdownField) {
              case SupportingDocumentDropdownFields.contentGroup: {
                supportingDocument.contentGroup = value
                supportingDocument.attachmentType = AddAttachmentsRPUtils.isDisableAttachmentType(
                  value
                )
                  ? ''
                  : supportingDocument.attachmentType
                supportingDocument.internalAttachmentType =
                  AddAttachmentsRPUtils.isDisableInternalAttachmentType(value)
                    ? ''
                    : supportingDocument.internalAttachmentType
                supportingDocument.issueDate =
                  supportingDocument.contentGroup === 'TRCertificate' ? props.issueDate : null

                break
              }
              case SupportingDocumentDropdownFields.type: {
                supportingDocument.type = value
                break
              }
              case SupportingDocumentDropdownFields.attachmentType: {
                supportingDocument.attachmentType = value
                break
              }
              case SupportingDocumentDropdownFields.internalAttachmentType: {
                supportingDocument.internalAttachmentType = value
                break
              }
              default:
                break
            }
          }
          return supportingDocument
        })
      }
      return cur
    })

    props.setRPAttachments(cloneCurrent)
  }

  const handleSupportingDocumentUpload = async (incomingFiles: File[]) => {
    const processedFiles = incomingFiles.map(file => {
      const hasExistingFileName = props?.value?.some(
        gridItem => gridItem.documentFileName === file.name
      )

      const fileResult = AddAttachmentsRPFileValidatorHelper.Common(
        {
          fileName: file.name,
          fileSize: file.size,
          hasDuplicate: hasExistingFileName,
        },
        {
          maximumFileSizeAllowed: MAXIMUM_ALLOWED_UPLOAD_RP_FILE_SIZE,
          allowedFileTypes: supportingDocumentsAllowedFileTypes,
        }
      )

      const processedFile: IAddAttachmentsRPTestSupportingDocumentModel = {
        id: uuid(),
        documentFileName: file.name,
        // rpFileNamePreview: "",
        fileNumber: props.fileNumber,
        projectNumber: props.projectNumber,
        serviceRequestNumber: props.serviceRequestNumber,
        contentGroup: '',
        type: props.type,
        certificateNumber: AddAttachmentsRPUtils.formatCertificateNumber(
          props.certificateNumber,
          props.revisionNumber
        ),
        standardNumber: props.standardNumber,
        revisionNumber: props.revisionNumber,
        issueDate: props.issueDate,
        attachmentType: '',
        internalAttachmentType: '',
        isValid:
          fileResult === RPFileValidatorSuccessMessage.FileUploadedReadyToLink ||
          fileResult === RPFileValidatorSuccessMessage.FileUploadedSuccessful,
        fileResult: fileResult,
        status: null,
        ecmFileName: null,
        file: file,
      }

      return processedFile
    })

    const updateSupportingDocument = structuredClone(props.rpAttachments).map(
      testReportDocument => {
        if (testReportDocument.id === props.parentId) {
          testReportDocument.supportingDocuments = [
            ...testReportDocument.supportingDocuments,
            ...processedFiles,
          ]
        }

        return testReportDocument
      }
    )

    props.setRPAttachments(updateSupportingDocument)

    const isAllChecked =
      updateSupportingDocument
        .filter(rpAttachment => rpAttachment.id === props.parentId)
        .flatMap(rpAttachment =>
          rpAttachment.supportingDocuments.filter(
            suppDoc =>
              !AddAttachmentsRPUtils.isFieldReadonly(
                suppDoc.ecmFileNodeId,
                props.isCertificateFromRevision
              ) && suppDoc.isValid
          )
        ).length === selectedRows.length
    setIsSelectAll(isAllChecked)
  }

  const handleCertificateNumberInput = (id: string, value: string) => {
    const cloneTR = structuredClone(props.rpAttachments).map(cur => {
      if (cur.id === props.parentId) {
        cur.supportingDocuments = cur.supportingDocuments.map(supportingDocument => {
          if (supportingDocument.id === id) {
            supportingDocument.certificateNumber = value
          }
          return supportingDocument
        })
      }
      return cur
    })

    props.setRPAttachments(cloneTR)
  }

  const handleBulkEdit = (isContentGroup: boolean) => {
    setBulkEditDialog(current => ({
      ...current,
      dropdownOptions: isContentGroup ? filteredCgDropdownSecondLevelOptions : rtDropdownOptions,
      title: isContentGroup ? 'Content Group' : 'Type',
      visible: true,
      isContentGroup: isContentGroup,
    }))
  }

  const handleBulkEditConfirm = (updatedValue: string) => {
    const updatedGridItems = structuredClone(props.rpAttachments).map((testReport, index) => {
      if (testReport.id !== props.parentId) return testReport

      testReport.supportingDocuments = testReport.supportingDocuments.map(suppDoc => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(
            suppDoc.ecmFileNodeId,
            props.isCertificateFromRevision
          )
        ) {
          return suppDoc
        }

        if (!selectedRows.some(selected => selected.id === suppDoc.id)) return suppDoc

        if (bulkEditDialog.isContentGroup) {
          suppDoc.contentGroup = updatedValue

          if (updatedValue === 'TRCertificate') suppDoc.issueDate = props.issueDate
          else suppDoc.issueDate = null
        } else suppDoc.type = updatedValue
        return suppDoc
      })
      return testReport
    })

    props.setRPAttachments(updatedGridItems)
    resetBulkEditState()
  }

  const resetBulkEditState = () => {
    setBulkEditDialog(current => ({
      ...current,
      visible: false,
      dropdownOptions: [],
      title: '',
      isContentGroup: false,
    }))
  }

  const supportingDocumentDropzoneOptions: DropzoneOptions = {
    onDrop: handleSupportingDocumentUpload,
  }

  const supportingDocumentsDropzone = useDropzone({
    noClick: true,
    noKeyboard: true,
    ...supportingDocumentDropzoneOptions,
  })

  const displayUnlinkEcmModalText = () => {
    return (
      <span>
        This change will not affect the document in ECM TIC.
        <br />
        <br />
        Are you sure you want to unlink the selected Document(s)?
      </span>
    )
  }

  const handleUpdateDocumentsStatus = (status: CertificateDocumentStatus, documentId: string) => {
    props.setRPAttachments((prevState: IAddAttachmentsRPTestReportModel[]) => {
      const newState = prevState.map((parent: IAddAttachmentsRPTestReportModel) => {
        parent.supportingDocuments.forEach(
          (supporting: IAddAttachmentsRPTestSupportingDocumentModel) => {
            if (supporting.id === documentId) supporting.status = status
          }
        )

        return parent
      })

      if (props.updateRPAttachmentOnParent) props.updateRPAttachmentOnParent(newState)

      return newState
    })
  }

  const handleLinkToWb = async (toLinkDocuments: IAddAttachmentsRPTestReportModel) => {
    if (!toLinkDocuments) return

    const linkRequestProps: IEcmCertificateDocumentActionRequest = {
      certificateDocumentId: toLinkDocuments?.id,
      ecmFileNodeId: toLinkDocuments?.ecmFileNodeId ?? '',
      certificateId: props.certificateId ?? '',
      handleUpdateDocumentsStatus: handleUpdateDocumentsStatus,
    }

    await certificateDocumentHook.handleLinkToWb(linkRequestProps)
  }

  const handleUnlinkFileFromWB = async (toUnlinkDocuments: IAddAttachmentsRPTestReportModel) => {
    setConfirmationModalProps(initialConfirmationModalValues)

    const unlinkRequestProps: IEcmCertificateDocumentActionRequest = {
      certificateDocumentId: toUnlinkDocuments?.id,
      ecmFileNodeId: toUnlinkDocuments?.ecmFileNodeId ?? '',
      certificateId: props.certificateId ?? '',
      handleUpdateDocumentsStatus: handleUpdateDocumentsStatus,
    }

    await certificateDocumentHook.handleUnlinkToWb(unlinkRequestProps)
  }

  const handleUnlinkConfirmationModalProps = (
    toUnlinkDocuments: IAddAttachmentsRPTestReportModel
  ) => {
    setConfirmationModalProps(current => {
      return {
        ...current,
        headerDisplay: displayUnlinkEcmModalHeader,
        confirmationMessageHTML: displayUnlinkEcmModalText(),
        visible: true,
        onCancel: () => {
          setConfirmationModalProps(initialConfirmationModalValues)
        },
        onConfirm: () => {
          handleUnlinkFileFromWB(toUnlinkDocuments)
        },
      }
    })
  }

  const columns: ColumnProps[] = [
    {
      header: options => {
        return (
          <Checkbox
            key={'rp-test-report-checkbox-header'}
            checked={isSelectAll}
            disabled={getSelectableRowsForCurrentParent().length === 0}
            onChange={e => handleCheckboxSelection(true, e.checked)}
          />
        )
      },
      style: { width: '3rem', maxWidth: '3rem', flex: 'none' },
      headerStyle: { width: '3rem' },
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel, options) => {
        return (
          <Checkbox
            key={`checkbox-${data.id}`}
            checked={selectedRows.some(selectedRow => selectedRow.id === data.id)}
            disabled={!isSelectableRow(data)}
            onChange={e => handleCheckboxSelection(false, e.checked, data)}
          />
        )
      },
    },
    {
      header: 'Document File Name',
      field: 'documentFileName',
      style: { width: '13rem', minWidth: '13rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        const fileName = data.ecmFileNodeId
          ? (data.ecmFileName ?? '')
          : (data.documentFileName ?? data.ecmFileName)

        return (
          <span
            className={clsx({
              [classes['add-attachments-rp-cell-link']]: data.ecmFileNodeId,
            })}
            title={fileName}
            onClick={() => (data.ecmFileNodeId ? props.downloadFile(data) : undefined)}
          >
            {fileName}
          </span>
        )
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      header: <span style={{ visibility: 'hidden' }}>status</span>,
      field: 'status',
      style: {
        width: '2.5rem',
        maxWidth: '2.5rem',
        textAlign: 'center',
        paddingBottom: '0.25rem',
        verticalAlign: 'center',
      },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        if (data.status === null) return <></>
        const isLinkUnlink =
          data.status === CertificateDocumentStatus.UnlinkingInProgress ||
          data.status === CertificateDocumentStatus.UploadToEcmInProgress

        return (
          <CertificateDetailsRPStatusIcon
            size="1x"
            rpAttachmentFile={data}
            isLinkInProcess={isLinkUnlink}
          />
        )
      },
      bodyClassName: `${classes['add-attachments-rp-cell']}`,
    },
    {
      header: 'File Number',
      field: 'fileNumber',
      style: { width: '10rem', minWidth: '10rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        return <span title={data.fileNumber}>{data.fileNumber}</span>
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      header: 'Project / SR Number',
      field: 'projectNumber',
      style: { width: '12rem', minWidth: '12rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        const serviceNumber = data?.serviceRequestNumber ?? data?.projectNumber
        return <span title={serviceNumber}>{serviceNumber}</span>
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      headerClassName: classes['add-attachments-column-with-bulk-edit'],
      header: () => {
        const hasValidSelection =
          getSelectedRowsForCurrentParent().length > 0 &&
          getSelectedRowsForCurrentParent().some(
            row => row.isValid && !AddAttachmentsRPUtils.isFieldReadonly(row.ecmFileNodeId)
          )

        return (
          <div className={classes['add-attachments-column-with-bulk-edit-row']}>
            <span>
              Content Group
              <RequiredAsterisk style={{ paddingLeft: '0.3rem' }} />
            </span>
            <FontAwesomeIcon
              className={clsx(classes['add-attachments-column-with-bulk-edit-row-icon'], {
                [classes['add-attachments-column-with-bulk-edit-row-icon-disabled']]:
                  !hasValidSelection,
              })}
              icon={faEdit}
              onClick={e => (hasValidSelection ? handleBulkEdit(true) : undefined)}
            />
          </div>
        )
      },
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel, options: ColumnBodyOptions) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span title={data.contentGroup}>{data.contentGroup}</span>
        }

        return (
          <Dropdown
            className={clsx(classes['add-attachments-rp-dropdown'], {
              'add-attachments-rp-cell-error ': !data.contentGroup,
            })}
            value={data.contentGroup}
            disabled={addAttachmentsRPContext.ecmCategoryDropdownLoading || !data.isValid}
            placeholder={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ? 'Loading...' : 'Select'
            }
            options={filteredCgDropdownSecondLevelOptions}
            dropdownIcon={
              addAttachmentsRPContext.ecmCategoryDropdownLoading
                ? 'pi pi-spin pi-spinner'
                : undefined
            }
            onChange={e =>
              handleDropdownChange(SupportingDocumentDropdownFields.contentGroup, data, e.value)
            }
            style={{ width: '100%' }}
            tooltip={data.contentGroup}
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
          />
        )
      },
      style: { width: '15rem', minWidth: '15rem' },
      className: classes['column-flex-style'],
    },
    {
      header: 'Attachment Type',
      field: 'attachmentType',
      style: { width: '14rem', minWidth: '14rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel, options: ColumnBodyOptions) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.attachmentType}</span>
        }

        const isDisableAttachmentType = AddAttachmentsRPUtils.isDisableAttachmentType(
          data.contentGroup
        )

        return (
          <Dropdown
            className={classes['add-attachments-rp-dropdown']}
            value={data.attachmentType}
            disabled={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ||
              !data.isValid ||
              isDisableAttachmentType
            }
            placeholder={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ? 'Loading...' : 'Select'
            }
            options={attachmentTypeDropdownOptions}
            dropdownIcon={
              addAttachmentsRPContext.ecmCategoryDropdownLoading
                ? 'pi pi-spin pi-spinner'
                : undefined
            }
            onChange={e =>
              handleDropdownChange(SupportingDocumentDropdownFields.attachmentType, data, e.value)
            }
            style={{ width: '100%' }}
            tooltip={data.attachmentType}
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
          />
        )
      },
    },
    {
      header: 'Issue Date',
      field: 'issueDate',
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        if (AddAttachmentsRPUtils.isContentGroupTRCertificate(data.contentGroup)) {
          const formattedDate = formatRPDate(data?.issueDate)
          return <span title={formattedDate?.toString()}>{formattedDate}</span>
        }

        return <></>
      },
      style: { width: '8rem', minWidth: '8rem' },
      className: classes['column-flex-style'],
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      headerClassName: classes['add-attachments-column-with-bulk-edit'],
      header: () => {
        const hasValidSelection =
          getSelectedRowsForCurrentParent().length > 0 &&
          getSelectedRowsForCurrentParent().some(
            row => row.isValid && !AddAttachmentsRPUtils.isFieldReadonly(row.ecmFileNodeId)
          )

        return (
          <div className={classes['add-attachments-column-with-bulk-edit-row']}>
            <span>
              Type
              <RequiredAsterisk style={{ paddingLeft: '0.3rem' }} />
            </span>
            <FontAwesomeIcon
              className={clsx(classes['add-attachments-column-with-bulk-edit-row-icon'], {
                [classes['add-attachments-column-with-bulk-edit-row-icon-disabled']]:
                  !hasValidSelection,
              })}
              icon={faEdit}
              onClick={e => (hasValidSelection ? handleBulkEdit(false) : undefined)}
            />
          </div>
        )
      },
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel, options: ColumnBodyOptions) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.type}</span>
        }

        return (
          <Dropdown
            className={clsx(classes['add-attachments-rp-dropdown'], {
              'add-attachments-rp-cell-error ': !data.type,
            })}
            value={data.type}
            disabled={addAttachmentsRPContext.ecmCategoryDropdownLoading || !data.isValid}
            placeholder={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ? 'Loading...' : 'Select'
            }
            options={rtDropdownOptions}
            dropdownIcon={
              addAttachmentsRPContext.ecmCategoryDropdownLoading
                ? 'pi pi-spin pi-spinner'
                : undefined
            }
            onChange={e =>
              handleDropdownChange(SupportingDocumentDropdownFields.type, data, e.value)
            }
            style={{ width: '100%' }}
            tooltip={data.type}
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
          />
        )
      },
      style: { width: '14rem', minWidth: '14rem' },
      className: classes['column-flex-style'],
    },
    {
      header: 'Certificate Number',
      field: 'certificateNumber',
      style: { width: '12rem', minWidth: '12rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.certificateNumber}</span>
        }

        return (
          <InputText
            type="text"
            className={clsx(classes['add-attachments-rp-row-input-text'], {
              'add-attachments-rp-cell-error':
                !data.certificateNumber &&
                AddAttachmentsRPUtils.isContentGroupTRCertificate(data.contentGroup),
            })}
            value={data.certificateNumber}
            onChange={e => handleCertificateNumberInput(data.id, e.target.value)}
          />
        )
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      header: 'Standard Number',
      field: 'standardNumber',
      style: { width: '12rem', minWidth: '12rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        if (AddAttachmentsRPUtils.isContentGroupTRCertificate(data.contentGroup)) {
          return <span title={standardNumber}>{standardNumber}</span>
        }
        return <></>
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      header: 'Internal Attachment Type',
      field: 'internalAttachmentType',
      style: { width: '15rem', minWidth: '15rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel, options: ColumnBodyOptions) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.internalAttachmentType}</span>
        }

        const isDisableInternalAttachmentType =
          AddAttachmentsRPUtils.isDisableInternalAttachmentType(data.contentGroup)

        return (
          <Dropdown
            className={classes['add-attachments-rp-dropdown']}
            value={data.internalAttachmentType}
            disabled={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ||
              !data.isValid ||
              isDisableInternalAttachmentType
            }
            placeholder={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ? 'Loading...' : 'Select'
            }
            options={internalAttachmentTypeDropdownOptions}
            dropdownIcon={
              addAttachmentsRPContext.ecmCategoryDropdownLoading
                ? 'pi pi-spin pi-spinner'
                : undefined
            }
            onChange={e =>
              handleDropdownChange(
                SupportingDocumentDropdownFields.internalAttachmentType,
                data,
                e.value
              )
            }
            style={{ width: '100%' }}
            tooltip={data.internalAttachmentType}
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
          />
        )
      },
    },
    {
      header: 'ECM Node ID',
      field: 'ecmFileNodeId',
      style: { width: '10rem', minWidth: '10rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel) => {
        return <span title={data.ecmFileNodeId}>{data.ecmFileNodeId}</span>
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']}`,
    },
    {
      header: '',
      field: 'fileResult',
      bodyClassName: `${classes['add-attachments-rp-cell']}`,
      body: (data: IAddAttachmentsRPTestSupportingDocumentModel, options: ColumnBodyOptions) => {
        const statusClassName = clsx(
          { [classes['error']]: !data.isValid },
          { [classes['warning']]: false },
          { [classes['success']]: data.isValid }
        )

        return (
          <>
            <div
              className={clsx(
                classes['add-attachments-rp-file-status-container'],
                'text-overflow-ellipsis'
              )}
              title={data.fileResult}
            >
              <span title={data.fileResult} className={statusClassName}>
                {data.fileResult}
              </span>
            </div>
          </>
        )
      },
      style: {
        flexGrow: 1,
        flexBasis: '20rem',
        width: '20rem',
      },
      align: 'right',
    },
    {
      header: '',
      style: {
        minWidth: '3rem',
        maxWidth: '15rem',
        flex: '0 0 auto',
        padding: '0',
        paddingRight: '.5rem',
      },
      body: (data, options) => {
        const icon = faLink
        const { label, buttonType, documentAction } =
          data.status === CertificateDocumentStatus.SavedInEcmTic
            ? {
                label: LinkToWbBtnText,
                buttonType: RPAttachmentLinkButtonEnum.linkToWb,
                documentAction: handleLinkToWb,
              }
            : {
                label: UnlinkEcmBtnText,
                buttonType: RPAttachmentLinkButtonEnum.unlinkEcm,
                documentAction: handleUnlinkConfirmationModalProps,
              }

        const isStatusBlue =
          (data.status === CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic ||
            data.status === CertificateDocumentStatus.UploadToEcmFailed) &&
          !data.ecmFileNodeId

        return (
          <>
            {(data.status === CertificateDocumentStatus.LinkedToWbAndEcmTic ||
              data.status === CertificateDocumentStatus.SavedInEcmTic) &&
              AddAttachmentsRPUtils.isDocumentAllowedToLink(
                props.certificateScheme,
                data.contentGroup,
                data.attachmentType
              ) &&
              props.isCertificateFromRevision && (
                <CertificateDetailsRPLinkButton
                  label={label}
                  icon={icon}
                  linkButtonType={buttonType}
                  onClick={() => documentAction(data)}
                />
              )}

            {!data.ecmFileNodeId && (
              <Button
                className={`p-button-rounded p-button-secondary p-button-text p-button-sm ${classes['add-attachments-rp-file-delete-attachment']}`}
                title="Delete Attachment"
                onClick={() => {
                  if (isStatusBlue) {
                    showDeleteFileBlobPrompt(data, options.rowIndex)
                  } else {
                    handleDeleteFileAttachment(options.rowIndex, data)
                  }
                }}
              >
                <FontAwesomeIcon
                  style={{ color: 'black' }}
                  icon={isStatusBlue ? faTrash : faClose}
                />
              </Button>
            )}
          </>
        )
      },
    },
  ]

  return (
    <div className={classes['add-attachments-rp-row-expansion-wrapper']}>
      <input {...supportingDocumentsDropzone.getInputProps()} />
      <div className={`${classes['add-attachments-rp-row-expansion-action-row']}`}>
        <div className={classes['add-attachments-rp-row-expansion-action-row-items']}>
          <AddAttachmentsRPSupportingDocumentButton
            openFileDialog={supportingDocumentsDropzone.open}
          />
          <div
            style={{
              fontStyle: 'italic',
              fontSize: '0.9rem',
            }}
          >
            Allowed File Type: (JPG, JPEG, DOC, DOCX, XLS, XLSX, TXT, BMP, GIF, PDF, PNG, MSG, ZIP)
          </div>
        </div>
      </div>
      <AddAttachmentsRPGrid
        columns={
          props.isCertificateFromRevision || props.isEditOrModify
            ? columns
            : columns?.filter(col => col.field !== 'status')
        }
        dtProps={gridProps}
        gridContainerClassName={classes['add-attachments-rp-grid-wrapper']}
      />

      <AddAttachmentsRPBulkEditDialog
        title={bulkEditDialog.title}
        subHeader={'For Supporting Document'}
        dropdownOption={bulkEditDialog.dropdownOptions}
        visible={bulkEditDialog.visible}
        onCancel={resetBulkEditState}
        onConfirm={handleBulkEditConfirm}
      />

      <ConfirmationModal {...confirmationModalProps} />
    </div>
  )
}

export default AddAttachmentsRPTRSupportDoc
